import React from "react";
import { Box, Rating, styled, Typography } from "@mui/material";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { allImages } from "../../../assets";
import GlobalButton from "../../../components/CustomButton";
import ArrowRightAltSharpIcon from "@mui/icons-material/ArrowRightAltSharp";

const MainView = styled(Box)(({ theme }) => ({
  position: "relative",
  backgroundColor: "#ffffff",
  maxWidth: "1200px",
  margin: "auto",
  padding: "16px",

  "& .lpl_ts_gr": {
    fontWeight: 700,
    fontSize: "2.5rem",
    textAlign: "center",
    background: "linear-gradient(90deg, #EA580C 0%, #000000 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    marginBottom: "1rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2rem",
    },
  },

  "& .lpl_ts_card": {
    position: "relative",
    margin: "0px 8px",
    // marginBottom: "2rem", // Add margin for spacing between cards
  },
}));

const data = [
  {
    image: allImages.landingSpaImage1,
    title:
      "Your SAAS spa and salon system has transformed the way we do business",
    rating: 4.5,
  },
  {
    image: allImages.landingSpaImage2,
    title:
      "The intuitive interface and robust features make managing appointments,",
    rating: 5,
  },
  {
    image: allImages.landingSpaImage3,
    title:
      "The mobile app has made it incredibly convenient for our clients to book appointments and stay engaged",
    rating: 4.5,
  },
];

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

function Testimonials() {
  return (
    <MainView my={{ xs: 3, md: 4 }}>
      <Typography variant="h1" className="lpl_ts_gr">
        Our customers say it best
      </Typography>
      <Typography variant={"body1"} textAlign={"center"}>
        Accelerate your business growth with our comprehensive SAAS spa and
        salon system. Our innovative platform equips you with the tools and
        insights needed to expand your client base, increase revenue, and
        enhance operational efficiency.
      </Typography>
      <Carousel
        responsive={responsive}
        infinite={true}
        autoPlaySpeed={3000}
        arrows={true}
      >
        {data.map((testimonial, index) => (
          <Box key={index} className={"lpl_ts_card"}>
            <Box
              height={230}
              borderRadius={3}
              overflow={"hidden"}
              position={"relative"}
              top={55}
            >
              <img
                src={testimonial.image}
                alt={testimonial.title}
                width={"100%"}
                style={{ objectFit: "cover" }}
              />
            </Box>
            <Box
              width={"80%"}
              padding={2}
              bgcolor={"#F5F7FA"}
              position={"relative"}
              bottom={20}
              textAlign={"center"}
              borderRadius={3}
              boxShadow=" 0px 5.57px 11.14px 0px #ABBED166"
              margin={"auto"}
              
            >
              <Typography
                variant="body2"
                color={"#717171"}
                lineHeight={"normal"}
                mb={2}
              >
                {testimonial.title}
              </Typography>
              <Rating
                name="size-small"
                defaultValue={testimonial.rating}
                size="medium"
              />
              <GlobalButton
                variant={"none"}
                btnText={"Read more"}
                endIcon={
                  <ArrowRightAltSharpIcon
                    htmlColor="#4CAF4F"
                    sx={{ fontSize: "2rem" }}
                  />
                }
                styleProps={{ color: "#4CAF4F" }}
              />
            </Box>
          </Box>
        ))}
      </Carousel>
    </MainView>
  );
}

export default Testimonials;
